import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import ReactPlayer from 'react-player';
import format from 'date-fns/format';
import Box from '@material-ui/core/Box';
import _ from 'lodash';
import { Paper } from '@material-ui/core';
import Button from '../../components/Button/CustomButton';
import GridItem from '../../components/Grid/GridItem';
import WrapperContainer from '../../components/Container/WrapperContainer';
import GridContainer from '../../components/Grid/GridContainer';
import CustomTypography from '../../components/Typography/CustomTypography';
import ListSeminarRegisteredManagermentStyle from '../../assets/jss/pages/ListSeminarRegisteredManagermentStyle';
import { PAID, MEDIA_TYPE } from '../../common/Constants';
import ViewHeader from '../../components/Header/ViewHeader';
import Snackbar from '../../components/Snackbar/Snackbar';

const useStyles = makeStyles(ListSeminarRegisteredManagermentStyle);

export const Header = (props) => {
    const { eventInfo, customText } = props;
    const intl = useIntl();
    return (
        <>
            {!_.isEmpty(eventInfo) && (
                <ViewHeader
                    eventName={eventInfo.name}
                    title={customText?.screen_name?.seminar_registered_details || intl.formatMessage({ id: 'seminar.detailSeminarRegister' })}
                    isIntl={false}
                    eventInfo={eventInfo}
                />
            )}
        </>
    );
};

Header.defaultProps = {
    eventInfo: {},
    customText: {},
};

Header.propTypes = {
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
};

const DetailSeminarRegistered = (props) => {
    const {
        fetchDetailSeminarRegistered,
        detailSeminar,
        token,
        clearData,
        customText,
        customColorSeminar,
        eventInfo,
        getDetailSeminar,
        clearDetailSeminar,
        getCustomText,
        clearCustomText,
        locale,
    } = props;
    const routeParams = useParams();
    const { shortName, seminarId } = routeParams;
    const classes = useStyles(customColorSeminar);
    const intl = useIntl();
    const queryString = new URLSearchParams(useLocation().search);
    const isPreview = queryString.get('is_preview');
    const history = useHistory();
    const [params, setParams] = useState({});
    const [seminarRuned, setSeminarRuned] = useState(false);
    const [snackbar, setSnackbar] = useState({ isOpen: false, type: 'success', message: '' });

    useEffect(() => {
        if (isPreview) {
            getDetailSeminar({ seminarId, language: locale });
            getCustomText({
                eventShortName: shortName,
                site: 0,
                text_type: 1,
                language: locale,
            });
        } else {
            fetchDetailSeminarRegistered({ event_name: shortName, seminar_id: seminarId, language: locale });
        }
        return () => {
            if (isPreview) {
                clearDetailSeminar();
                clearCustomText();
            } else {
                clearData();
            }
        };
    }, [shortName, seminarId, locale]);

    useEffect(() => {
        if (detailSeminar) {
            setParams(detailSeminar);
            setSeminarRuned(checkTime(detailSeminar));
        }
    }, [detailSeminar]);

    const checkTime = (data) => {
        const utcDateNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));
        const timeRunningStart = new Date(`${data.date} , ${data.stime}`);
        return utcDateNow >= timeRunningStart;
    };
    const renderButton = (title, href, target) => (
        <Button
            color="navy"
            gradient
            size="sm"
            round
            className={classes.btnStyle}
            href={!isPreview && href}
            onClick={isPreview && handleSnackbar}
            target={target}
            buttonTextColor={customColorSeminar?.button_text_color}
            buttonBackgroundColor={customColorSeminar?.button_background_color?.common_button}
        >
            {title}
        </Button>
    );

    const handleSnackbar = () => {
        if (isPreview) {
            setSnackbar({
                ...snackbar,
                isOpen: true,
                type: 'error',
                message: intl.formatMessage({ id: 'common.noPreview' }),
            });
        }
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, isOpen: false });
    };

    const renderView = () => (
        <>
            <GridItem md={12} className={classes.leftContent}>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold customColor={customColorSeminar?.contents_text_color}>
                            {customText?.field_name?.seminar_time || intl.formatMessage({ id: 'seminar.period' })}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography className={classes.dataText} customColor={customColorSeminar?.contents_text_color}>
                            {params.date && format(new Date(params.date), 'yyyy/MM/dd')}
                                    &#160;
                                    &#160;
                            {params.stime}
                            {' '}
                            ~
                            {' '}
                            {params.etime}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold customColor={customColorSeminar?.contents_text_color}>
                            {customText?.field_name?.lecture_name || intl.formatMessage({ id: 'seminar.lectureName' })}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography className={classes.dataText} customColor={customColorSeminar?.contents_text_color}>
                            {params.title}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold customColor={customColorSeminar?.contents_text_color}>
                            {customText?.field_name?.speaker || intl.formatMessage({ id: 'seminar.speaker' })}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography className={classes.dataText} customColor={customColorSeminar?.contents_text_color}>
                            {params.speaker}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold customColor={customColorSeminar?.contents_text_color}>
                            {customText?.field_name?.speaker_photo || intl.formatMessage({ id: 'seminar.speakerPhoto' })}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography customColor={customColorSeminar?.contents_text_color}>
                            <img src={params.speaker_img} alt="" style={{ borderRadius: '10px', maxWidth: '100%', maxHeight: '200px' }} />
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                {locale === 'ja' && (
                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={3} md={3}>
                            <CustomTypography bold customColor={customColorSeminar?.contents_text_color}>
                                {customText?.field_name?.speaker_profile || intl.formatMessage({ id: 'seminar.speakerProfile' })}
                            </CustomTypography>
                        </GridItem>
                        <GridItem xs={12} sm={9} md={9}>
                            <CustomTypography className={classes.dataText} customColor={customColorSeminar?.contents_text_color}>
                                {params.speaker_profile}
                            </CustomTypography>
                        </GridItem>
                    </GridContainer>
                )}
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold customColor={customColorSeminar?.contents_text_color}>
                            {customText?.field_name?.lecture_content || intl.formatMessage({ id: 'seminar.lectureContent' })}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography className={classes.dataText} customColor={customColorSeminar?.contents_text_color}>
                            {params.content}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold customColor={customColorSeminar?.contents_text_color}>
                            {customText?.field_name?.maximum_applicants || intl.formatMessage({ id: 'seminar.maxApplicant' })}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        {
                            !(params.limit === -1) ? (
                                <CustomTypography className={classes.dataText} customColor={customColorSeminar?.contents_text_color}>
                                    {params.limit}
                                    {' '}
                                    {intl.formatMessage({ id: 'common.people' }).toLocaleLowerCase()}
                                </CustomTypography>
                            ) : (
                                <CustomTypography className={classes.dataText} customColor={customColorSeminar?.contents_text_color}>
                                    {intl.formatMessage({ id: 'noLimit' })}
                                </CustomTypography>
                            )
                        }
                    </GridItem>
                </GridContainer>
                <GridContainer className={classes.spacing}>
                    <GridItem xs={12} sm={3} md={3}>
                        <CustomTypography bold customColor={customColorSeminar?.contents_text_color}>
                            {customText?.field_name?.course_fee || intl.formatMessage({ id: 'seminar.courseFee' })}
                        </CustomTypography>
                    </GridItem>
                    <GridItem xs={12} sm={9} md={9}>
                        <CustomTypography className={classes.dataText} customColor={customColorSeminar?.contents_text_color}>
                            { params.cost > 0 ? `${intl.formatNumber(params.cost)}${intl.formatMessage({ id: 'common.yen' })}` : intl.formatMessage({ id: 'common.free' })}
                        </CustomTypography>
                    </GridItem>
                </GridContainer>
                { params.cost > 0 && (
                    <GridContainer className={classes.spacing}>
                        <GridItem xs={12} sm={3} md={3}>
                            <CustomTypography bold customColor={customColorSeminar?.contents_text_color}>
                                {customText?.field_name?.payment_status || intl.formatMessage({ id: 'seminar.paymentStatus' })}
                            </CustomTypography>
                        </GridItem>
                        {!isPreview && (
                            <GridItem xs={12} sm={9} md={9}>
                                <CustomTypography className={classes.dataText} customColor={customColorSeminar?.contents_text_color}>
                                    {params.is_paid ? PAID[locale].PAIDED : PAID[locale].UNPAID}
                                </CustomTypography>
                            </GridItem>
                        )}
                    </GridContainer>
                )}
            </GridItem>
            {params.media && (
                <GridItem xs={12} md={10} className={classes.sliderFirst}>
                    <ReactPlayer
                        controls
                        config={{
                            attributes: {
                                controlsList: 'nodownload',
                                style: {
                                    outline: 'none',
                                    margin: 'auto',
                                    maxHeight: '100%',
                                    width: '100%',
                                },
                            },
                            forceAudio: params.media_type === MEDIA_TYPE.AUDIO,
                        }}
                        height={params.media_type === MEDIA_TYPE.AUDIO ? 60 : 550}
                        width="100%"
                        url={params.media && `${params.media}?token=${token}`}
                        style={{ display: 'flex' }}
                    />
                </GridItem>
            )}

            <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap" width="100%">
                { params.document_link && renderButton(
                    customText?.button_name?.document_link || intl.formatMessage({ id: 'productRegister.documentRequestReception' }),
                    params.document_link, '_blank',
                )}
                { params.document && renderButton(
                    customText?.button_name?.document || intl.formatMessage({ id: 'exhibition.documentDownload' }),
                    params.document, '_blank',
                )}
                { params.link_contact && seminarRuned
                        && renderButton(
                            customText?.button_name?.link_contact || intl.formatMessage({ id: 'organizerBusinessContact.inquiries' }),
                            `https://mail.google.com/mail/?view=cm&fs=1&to=${params.link_contact}`, '_blank',
                        )}
                { params.survey_link && seminarRuned && renderButton(
                    customText?.button_name?.survey_link || intl.formatMessage({ id: 'productRegister.survey' }),
                    params.survey_link, '_blank',
                )}
            </Box>
        </>
    );

    const handleClickExitPreview = () => {
        history.push(`/${shortName}/seminar-management`);
    };

    return (
        <>
            {!_.isEmpty(eventInfo) && (
                <>
                    {
                        !isPreview ? (
                            <WrapperContainer xs={12} md={12} className={classes.wrapper}>
                                {renderView()}
                            </WrapperContainer>
                        ) : (
                            <WrapperContainer>
                                <GridContainer className={classes.buttonExit}>
                                    <Button
                                        style={{ fontSize: '1.2rem' }}
                                        color="info"
                                        size="dm"
                                        onClick={handleClickExitPreview}
                                    >
                                        Exit
                                    </Button>
                                </GridContainer>
                                <Paper
                                    md={12}
                                    elevation={1}
                                    classes={{ root: classes.preView }}
                                    style={{ background: eventInfo.settings_colors_viewer.screen_background_color }}
                                >
                                    {renderView()}
                                </Paper>
                            </WrapperContainer>
                        )
                    }
                </>

            )}
            <Snackbar
                open={snackbar.isOpen}
                onClose={handleCloseSnackbar}
                message={snackbar.message}
                severity={snackbar.type}
                autoHideDuration={1000}
            />
        </>
    );
};

DetailSeminarRegistered.defaultProps = {
    detailSeminar: {},
    token: '',
    customText: {},
    customColorSeminar: {},
    eventInfo: {},
    getCustomText: () => {},
    clearCustomText: () => {},
    locale: 'ja',
};

DetailSeminarRegistered.propTypes = {
    fetchDetailSeminarRegistered: PropTypes.func.isRequired,
    clearData: PropTypes.func.isRequired,
    getDetailSeminar: PropTypes.func.isRequired,
    clearDetailSeminar: PropTypes.func.isRequired,
    detailSeminar: PropTypes.oneOfType([() => null, PropTypes.object]),
    token: PropTypes.string,
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    customColorSeminar: PropTypes.oneOfType([() => null, PropTypes.object]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    getCustomText: PropTypes.func,
    clearCustomText: PropTypes.func,
    locale: PropTypes.func,
};

export default DetailSeminarRegistered;
